import React from "react";

import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import { Activity } from "@mapmycustomers/shared/types/entity";
import { UserRef } from "@mapmycustomers/shared/types/User";
import { stopEvents } from "@mapmycustomers/shared/util/browser";
import { Avatar, AvatarWithName } from "@mapmycustomers/ui";

import UserPreviewCard from "@app/component/UserPreviewCard";

import styles from "./ActivityAssignee.module.scss";

interface Props {
  activity: Activity;
  avatarClassName?: string;
  className?: string;
  showName?: boolean;
}

const ActivityAssignee = ({ activity, avatarClassName, className, showName = false }: Props) => {
  const assigner = activity.creator ?? activity.user;

  const renderAvatar = (user: UserRef) => (
    <UserPreviewCard userId={user.id}>
      {showName ? (
        <span>
          <AvatarWithName
            actionOnHover
            avatarClassName={cn(styles.avatar, avatarClassName)}
            user={user}
          />
        </span>
      ) : (
        <Avatar actionOnHover className={cn(styles.avatar, avatarClassName)} user={user} />
      )}
    </UserPreviewCard>
  );

  return (
    <div className={cn(styles.container, className)} onClick={stopEvents}>
      {activity.assignee && activity.assignee.id !== assigner.id ? (
        <div className={styles.differentAssigneeContainer}>
          {renderAvatar(assigner)}
          <FontAwesomeIcon className={styles.chevron} icon={faChevronRight} />
          {renderAvatar(activity.assignee)}
        </div>
      ) : (
        renderAvatar(assigner)
      )}
    </div>
  );
};

export default ActivityAssignee;
